import { render, staticRenderFns } from "./socialInfo.vue?vue&type=template&id=ce2205ac&scoped=true&"
import script from "./socialInfo.vue?vue&type=script&lang=js&"
export * from "./socialInfo.vue?vue&type=script&lang=js&"
import style0 from "./socialInfo.vue?vue&type=style&index=0&id=ce2205ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2205ac",
  null
  
)

export default component.exports